@if (widget.selector === 'smart-box') {
<div>
  <smart-box-v2 [apps]="companyProperties.userCompanyApps" [idx]="widget.idx" [editMode]="modify"
    [selectedDashboardButtons]="widget.dashboardAssociationParamValue" (dashboardParams)="saveSmartBoxParams($event)"
    (boxIndex)="setSmartBoxIndex($event)" (disableEditMode)="changeModi($event)"></smart-box-v2>
</div>
}

@if (widget.selector === 'crm-last-parties') {
<crm-last-parties [modify]="modify">
</crm-last-parties>
}

@if (widget.selector === 'crm-more-used') {
<crm-more-used [modify]="modify">
</crm-more-used>
}

@if (widget.selector === 'crm-party-search') {
<am-party-search [needoptions]="false" [editmode]="modify" [focusOnInput]="false" [widgetmode]="true"
  [user]="sessionService.getSession" [relationtypologies]="sessionService.relationTypologies"
  [baseurl]="appService.getServerBaseUrl" (resultItem)="selectParty($event)">
</am-party-search>
}


@if (widget.selector == 'calendar-party-activities') {
<div>
  <calendar-user-activities [modify]="modify" [idx]="widget.idx" [params]="widget.dashboardAssociationParamValue"
    (popup)="actpopUp($event)">
  </calendar-user-activities>
  @if (activpop) {
  <act-pop [idx]="selectedAct" [params]="selectedActParams" (saveData)="saveWidgetParams($event)"
    (closepopup)="actPopClose($event)">
  </act-pop>
  }
</div>
}

@if (widget.selector == 'calendar-activity-graphstate') {
<div>
  <state-chart [modify]="modify" [idx]="widget.idx" [params]="widget.dashboardAssociationParamValue"
    (popup)="statepopUp($event)">
  </state-chart>
  @if (statepop) {
  <activity-statePop [idx]="selectedState" [params]="selectedStateParams" (saveData)="saveWidgetParams($event)"
    (closepopup)="statePopClose($event)">
  </activity-statePop>
  }
</div>
}

@if (widget.selector == 'calendar-activity-typologygraph') {
<div>
  <typology-chart [modify]="modify" [idx]="widget.idx" [params]="widget.dashboardAssociationParamValue"
    (popup)="typologyPopUp($event)">
  </typology-chart>
  @if (typologypop) {
  <activity-typologyPop [idx]="selectedTypology" [params]="selectedTypologyParams" (saveData)="saveWidgetParams($event)"
    (closepopup)="typologyPopClose($event)">
  </activity-typologyPop>
  }
</div>
}

@if (widget.selector == 'calendar-activity-hoursgraph') {
<div>
  <hour-chart [modify]="modify" [idx]="widget.idx" [params]="widget.dashboardAssociationParamValue"
    (popup)="hourPopUp($event)">
  </hour-chart>
  @if (hourpop) {
  <hour-pop [idx]="selectedHour" [params]="selectedHourParams" (saveData)="saveWidgetParams($event)"
    (closepopup)="hourPopClose($event)">
  </hour-pop>
  }
</div>
}


@if (widget.selector === 'calendar-party-projects') {
<div>
  <calendar-user-projects [idx]="widget.idx" [modify]="modify" [params]="widget.dashboardAssociationParamValue"
    (pjpopup)="projectPopUp($event)">
  </calendar-user-projects>
  @if (pjpop) {
  <project-pop [idx]="selectedProj" [params]="selectedPjParams" (saveData)="saveWidgetParams($event)"
    (closepopup)="pjPopclose($event)">
  </project-pop>
  }
</div>
}


@if (widget.selector === 'templates-last-used') {
<templates-last-used [modify]="modify">
</templates-last-used>
}

@if (widget.selector === 'cpr-myrequest') {
<employee-causal-request-list [usermodel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl"
  [idParty]="userProperty.userPartyModel.id" [widget]="true" [editEnabled]="modify">
</employee-causal-request-list>
}

@if (widget.selector === 'clocking-approve-entries') {
<clocking-entry [usermodel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl"
  viewType="entryToApprove" [widget]="true" [editMode]="modify" [idx]="widget.idx"></clocking-entry>
}

@if (widget.selector === 'cpr-waiting-request') {
<employee-causal-request-list [usermodel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl"
  [idParty]="userProperty.userPartyModel.id" [widget]="true" [canManage]="true" [editEnabled]="modify">
</employee-causal-request-list>
}

@if (widget.selector === 'attendanceSheet-lul-summary') {
<attendancesheet-lul-summary [usermodel]="sessionService.getSession" [baseurl]="appService.getServerBaseUrl"
  [userOwners]="userProperty.userCompaniesList" [month]="month" [year]="year" [editMode]="modify" [idx]="widget.idx"
  [widgetMode]="true" [params]="widget.dashboardAssociationParamValue" (saveWidgetParams)="saveWidgetParams($event)">
</attendancesheet-lul-summary>
}

@if (widget.selector === 'dialog-sended') {
<dialog-message [usermodel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl" [editMode]="modify"
  [idx]="widget.idx" [params]="widget.dashboardAssociationParamValue" [widget]="true"
  [idDataOwner]="userProperty.userSelectedCompany.id" (saveWidgetParams)="saveWidgetParams($event)"
  (openDialog)="appStateHolder.navigateToAppFromEvent($event)">
</dialog-message>
}

@if (widget.selector=='party-accruals-summary') {
<party-accruals [idx]="widget.idx" [params]="widget.dashboardAssociationParamValue"
  [usermodel]="sessionService.getSession" [baseurl]="appService.getServerBaseUrl" [widgetMode]="true"
  [idParty]="userProperty.userPartyModel.id" [idPartyRelation]="null" [checkEmpVisibility]="true" [editMode]="modify"
  (saveWidgetParams)="saveWidgetParams($event)">
</party-accruals>
}

@if (widget.selector === 'employee-last-documents') {
<party-shared-lastdocuments [usermodel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl"
  [widget]="true" [editEnabled]="modify" partyType='party' (navigateToArchive)="navigateToArchive($event)">
</party-shared-lastdocuments>
}

@if (widget.selector === 'last-documents') {
<party-shared-lastdocuments [usermodel]="sessionService.getSession" (navigateToArchive)="navigateToArchive($event)"
  [baseUrl]="appService.getServerBaseUrl" [widget]="true" [editEnabled]="modify" partyType='company'>
</party-shared-lastdocuments>
}

@if (widget.selector === 'party-clocking-day') {
<party-clocking-day [usermodel]="sessionService.getSession" [userPartyModel]="userProperty.userPartyModel"
  [baseUrl]="appService.getServerBaseUrl" [editMode]="modify" [idx]="widget.idx"
  [params]="widget.dashboardAssociationParamValue" (navigateToMyClocking)="navigateToClocking($event)">
</party-clocking-day>
}

@if (widget.selector=='partyprofile-expiredcompetence') {
<party-profiler [modify]="modify" [idx]="widget.idx">
</party-profiler>
}

@if (widget.selector=='my-refunded-cost') {
<employee-refunded-costs [userModel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl"
  [idx]="widget.idx" [idCompany]="userProperty.userSelectedCompany.id" [idParty]="userProperty.userPartyModel.id"
  [editEnabled]="modify" [userPartyModelId]="userProperty.userPartyModel.id" [userIsApprover]="false" [widget]="true"
  viewType="party">
</employee-refunded-costs>
}

@if (widget.selector=='approver-refunded-cost') {
<employee-refunded-costs [userModel]="sessionService.getSession" [baseUrl]="appService.getServerBaseUrl"
  [idCompany]="userProperty.userSelectedCompany.id" [idParty]="userProperty.userPartyModel.id" [idx]="widget.idx"
  [userPartyModelId]="userProperty.userPartyModel.id" [userIsApprover]="false" [widget]="true" [editEnabled]="modify"
  [editModeParams]="widget.dashboardAssociationParamValue" (saveWidgetParams)="saveWidgetParams($event)">
</employee-refunded-costs>

<!-- DA SOSTITUIRE [params]="params CON I WIDGET PARAMS -->
}